/**
 * Created by sunjinyu on 2018/1/24.
 */
;
(function (win) {
  var doc = win.document

  var docEl = doc.documentElement

  var metaEl = doc.querySelector('meta[name="viewport"]')

  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'

  var tid

  if (!metaEl) {
    metaEl = doc.createElement('meta')

    metaEl.setAttribute('name', 'viewport')

    metaEl.setAttribute('content', 'width=device-width, initial-scale=' + 1.0 + ', maximum-scale=' + 1.0 + ', minimum-scale=' + 1.0 + ', user-scalable=0')

    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl)
    } else {
      var wrap = doc.createElement('div')

      wrap.appendChild(metaEl)

      doc.write(wrap.innerHTML)
    }
  } else {
    metaEl.setAttribute('name', 'viewport')

    metaEl.setAttribute('content', 'width=device-width, initial-scale=' + 1.0 + ', maximum-scale=' + 1.0 + ', minimum-scale=' + 1.0 + ', user-scalable=0')
  }

  function refreshRem() {
    var width = docEl.getBoundingClientRect().width

    /*if (width / dpr > 540) {

     width = 540 * dpr;

     }*/

    //淘宝方式1rem代表设计稿的十分之一
    var rem = width / 10

    // // 另一种方式，1rem改成设计稿上的100px，设计稿为750
    // var designWidth = 750;
    // var rem = width / designWidth * 100;

    docEl.style.fontSize = rem + 'px'
  }

  win.addEventListener(resizeEvt, function () {
    clearTimeout(tid)

    tid = setTimeout(refreshRem, 100)
  }, false)

  win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(tid)

      tid = setTimeout(refreshRem, 100)
    }
  }, false)

  refreshRem()
})(window)



// WEBPACK FOOTER //
// ./src/utils/rem.js